import { createContext, useContext } from "react";

export const ResizableContext = createContext(true);
ResizableContext.displayName = "ResizableContext";
export const useIsResizable = () => useContext(ResizableContext);
